/* global __APP_CONFIG__ */
/**
 * Public (unauthenticated) asset URLs served by the worker's deliberately
 * un-gated /api/public lane. These are NOT licensed feature routes. They are
 * decided-free (entitlement: null) platform surfaces, so their path lives in
 * the platform shared contracts (shared/features/platform.contracts.ts). This
 * module derives the concrete URL from the contract so no raw '/api/' literal
 * exists in frontend code; consumers embed the URL as an <img src>.
 */

import { contracts } from '../../../shared/features/platform.contracts'

const config = window.__APP_CONFIG__ || __APP_CONFIG__

/** The customer branding logo (PNG), served with the baked default when
 * no custom logo is uploaded. Append a cache-bust query when previewing. */
export const PUBLIC_BRANDING_LOGO_URL = new URL(
  contracts.publicBrandingLogo.build(),
  config.apiUrl,
).toString()

/** Notifies mounted chrome when Settings > Branding changes the logo. */
export const BRANDING_LOGO_CHANGED_EVENT = 'operations:branding-logo-changed'

/** Notifies BrandingContext when Settings changes runtime display config. */
export const BRANDING_CONFIG_CHANGED_EVENT = 'operations:branding-config-changed'
